import { fire } from 'delegated-events';
import helpers from './helpers';

export default (function () {
  return {
    init() {
      this.faqAccordion();
      this.faqHashChange();
    },

    faqAccordion() {
      const accordionBtn = [...document.querySelectorAll('.js-faq-accordion')];
      const currentPath = document.location;
      const currentPathHash = String(currentPath).split('#');

      helpers.forEach(accordionBtn, (i, elem) => {
        const elemID = elem.getAttribute('id');
        elem.addEventListener('click', (e) => {
          const heading = elem.querySelector('.faq__accordion-toggle');
          const content = elem.querySelector('.faq__accordion-content');

          elem.classList.toggle('open');
          heading.setAttribute(
            'aria-expanded',
            heading.getAttribute('aria-expanded') === 'true' ? 'false' : 'true',
          );
          content.setAttribute(
            'aria-hidden',
            content.getAttribute('aria-hidden') === 'true' ? 'false' : 'true',
          );
        });

        if (elemID === currentPathHash[currentPathHash.length - 1]) {
          // the ID that is used as an anchor on the FAQ button is the same as the URL hash - click on that button and open it
          setTimeout(() => {
            fire(elem, 'click');
          }, 100);
        }
      });
    },

    faqHashChange() {
      // add hashchange listener in case faq button has a anchor links that leads to another faq button on the same page
      window.addEventListener('hashchange', () => {
        const button = document.querySelector(
          `#${String(window.location.hash).split('#')[1]}`,
        );
        if (!button) return;
        setTimeout(() => {
          fire(button, 'click');
        }, 100);
      });
    },
  };
})();
